import { Form } from '@anytag/shared-atoms';
import { useUserRoleOptions } from './hooks';
import { UserFormSchema } from './schema';
import { Template } from './Template';
import { UserFormProps, UserFormValues } from './types';
import { defaultUserFormValues } from './utils';

export const UserForm = ({
  defaultValues = defaultUserFormValues,
  onSubmit,
  isUserSettingsForAdvertisers
}: UserFormProps) => {
  const userRoleOptions = useUserRoleOptions(defaultValues?.mode);

  return (
    <Form.Provider<UserFormValues>
      onSubmit={onSubmit}
      zodSchema={UserFormSchema}
      defaultValues={{
        ...defaultValues,
        userType: (defaultValues?.userType || userRoleOptions.at(0)?.value || '') as UserFormValues['userType']
      }}
    >
      <Template userRoleOptions={userRoleOptions} isUserSettingsForAdvertisers={isUserSettingsForAdvertisers} />
    </Form.Provider>
  );
};

export * from './types';
export * from './utils';
